import { Search, Filter, X } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';

interface BuscaFiltrosProps {
  search: string;
  onSearchChange: (value: string) => void;
  statusFilter: string;
  onStatusFilterChange: (value: string) => void;
}

const statusOptions = [
  { value: 'all', label: 'Todos os status' },
  { value: 'ativa', label: 'IA Ativa' },
  { value: 'desligada', label: 'IA Desligada' },
  { value: 'aguardando', label: 'Aguardando' },
  { value: 'reuniao', label: 'Reunião' },
  { value: 'inativo', label: 'Inativo' }
];

export function BuscaFiltros({ search, onSearchChange, statusFilter, onStatusFilterChange }: BuscaFiltrosProps) {
  const hasFilters = search || statusFilter !== 'all';

  const clearFilters = () => {
    onSearchChange('');
    onStatusFilterChange('all');
  };

  return (
    <div className="flex flex-col sm:flex-row gap-3">
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-ds-text-secondary" />
        <Input
          placeholder="Buscar por nome ou número..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-10"
        />
      </div>
      <div className="flex items-center gap-2">
        <Filter className="h-4 w-4 text-ds-text-secondary" />
        <select
          value={statusFilter}
          onChange={(e) => onStatusFilterChange(e.target.value)}
          className="bg-ds-surface2 border border-ds-border rounded-lg px-3 py-2 text-sm text-ds-text-primary focus:outline-none focus:ring-2 focus:ring-ds-success/50"
        >
          {statusOptions.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
        {hasFilters && (
          <Button variant="ghost" size="sm" onClick={clearFilters}>
            <X className="h-4 w-4" />
          </Button>
        )}
      </div>
    </div>
  );
}
